import { RevealText, Reveal } from "./Reveal";
import { BlueprintGrid } from "./Backdrop";

// Shared dark page hero band used at the top of inner pages.
export default function PageHero({ eyebrow, title, description, children }) {
  return (
    <section className="relative overflow-hidden bg-[#F3F7FB] pb-16 pt-[140px] md:pb-20 md:pt-[168px]">
      <BlueprintGrid />
      <div
        aria-hidden="true"
        className="pointer-events-none absolute inset-0 bg-[radial-gradient(60%_50%_at_50%_0%,rgba(16,185,129,0.13),transparent_70%)]"
      />
      <div className="wrap relative">
        {eyebrow && (
          <Reveal>
            <span className="eyebrow">{eyebrow}</span>
          </Reveal>
        )}
        <RevealText
          text={title}
          as="h1"
          className="mt-5 max-w-4xl font-display text-4xl font-extrabold uppercase leading-[1.02] tracking-tight text-ink sm:text-5xl lg:text-6xl"
        />
        {description && (
          <Reveal delay={0.2}>
            <p className="mt-6 max-w-2xl text-base leading-relaxed text-slate-500 sm:text-lg">{description}</p>
          </Reveal>
        )}
        {children}
      </div>
    </section>
  );
}
